import { lazy } from 'react';

const ApiPage = lazy(() => import('./ApiPage'));

const ApiAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/settings/api',
			element: <ApiPage />
		}
	]
};
export default ApiAppConfig;
